import { api } from '../index';

const prefix = '/api/search/';

export function apiSelectStateList() {
	return api.get(prefix + 'state');
}

export function apiSelectCountryList() {
	return api.get(prefix + 'country');
}
